import Resolution from 'engine/Resolution.js';
import {getTriggerTimes} from 'keyboard/TriggerTimeHelper.js';

const UP = 'UP';
const DOWN = 'DOWN';

/**
 * manages arpeggiation for a track
 * each track contains one
*/
class ArpManager {
    constructor() {
        this.enabled = false;
        this.noteToDuration = {};
        this.notes = [];
        this.index = 0;
        this.currentOctave = 0;
        this.arpRate = new Resolution(8, false);
        this.arpDirection = DOWN;
    }

    clear() {
        this.notesToDuration = {};
        this.notes = [];
        this.index = 0;
        this.currentOctave = 0;
    }

    setEnabled(enabled) {
        this.enabled = enabled;
    }

    toggleEnabled() {
        this.enabled = !this.enabled;
    }

    addNote(transpose, duration=undefined) {
        if (duration !== undefined) {
            if (transpose in this.noteToDuration) {
                this.noteToDuration[transpose] = this.noteToDuration[transpose] + duration*2
            } else {
                this.noteToDuration[transpose] = duration * 2;
            }
        }

        // todo: add note at the index so it plays next
        if (this.notes.indexOf(transpose) < 0) {
            this.notes.push(transpose);
            this.notes = this.notes.sort();

            if (this.arpDirection === DOWN) {
                this.notes.reverse();
            }
            this.index = this.notes.indexOf(transpose);
        }
    }

    removeNote(transpose) {
        let index = this.notes.indexOf(transpose);
        if (index > -1) {
            this.notes.splice(index, 1);
        }

        if (this.index >= this.notes.length) {
            this.index = 0;
            this.currentOctave = 0;
        }
    }

    nextNote(octaves) {
        if (this.notes.length == 0) {
            return undefined;
        }
        let note = this.notes[this.index];
        this.index = (this.index + 1) % this.notes.length;

        if (this.index == 0 && octaves > 0) {
            if (this.arpDirection === UP) {
                this.currentOctave = (this.currentOctave + 1) % (octaves + 1);
            } else if (this.arpDirection === DOWN) {
                this.currentOctave = (this.currentOctave - 1) % (octaves + 1);
            }
        }

        return note + 12 * this.currentOctave;
    }

    getNextTriggers(trackData, stepNumber) {
        let triggerTimes = getTriggerTimes(stepNumber, trackData.arpRate);

        let triggers = triggerTimes.map(
            triggerTime => {
                return {
                    transpose: this.nextNote(trackData.arpOctaves),
                    time: triggerTime.time,
                    step: triggerTime.step
                };
            })
            .filter(
                trigger =>
                    trigger.transpose !== undefined);

        // now reduce the duration of each note by 1 and delete
        // if needed
        for (let note in this.noteToDuration) {
            this.noteToDuration[note] -= 1;
            if (this.noteToDuration[note] <= 0) {
                delete this.noteToDuration[note];
                this.removeNote(parseInt(note));
            }
        }

        return triggers;
    }
}

export default ArpManager;
